module.exports = __webpack_public_path__ + "img/sound_icon.abfe8f62.png";